import { createSlice } from '@reduxjs/toolkit';
import {
  BULK_LEAD_CREATION,
  CHECK_LEAD_CREATION,
  CREATE_LEAD_B2B,
  CREATE_LEAD_B2C,
  FETCH_CSV_HISTORY,
  GET_LEAD_LIST,
  GET_ROW_ID_STATUS
} from 'redux/sagas/actions/lead';
import { SortDirection, StatusLead } from 'const';
import moment from 'moment';

const initialState = {
  pageNo: 0,
  pageSize: 10,
  returnedRecords: 10,
  searchPattern: '',
  isLoading: false,
  sortBy: 'LastModifiedDate',
  sortDirection: SortDirection.DESC,
  leads: [],
  isLoadingCheck: false,
  errorCheckAPI: false,
  checkWasDone: false,
  existingLeadId: '',
  isUploading: false,
  createdCount: 0,
  failedCount: 0,
  skippedCount: 0,
  totalCount: 0,
  historyList: [],
  fileDataList: [],
  isLoadingCreationBulk: false,
  showHistoryTab: false
};

const setCreateAccountsCSVResponse = (state, action) => {
  const {
    createdCount,
    failedCount,
    skippedCount,
    totalCount
  } = action.payload;
  state = {
    ...state,
    createdCount,
    failedCount,
    skippedCount,
    totalCount,
    postCSVSuccess: true,
    isLoadingCreationBulk: false
  };
  return state;
};

export const leadSlice = createSlice({
  name: '@@lead',
  initialState,
  reducers: {
    SHOW_SPINNER: state => ({
      ...state,
      isLoading: true
    }),
    HIDE_SPINNER: state => ({
      ...state,
      isLoading: false
    }),
    SET_SEARCH_PATTERN: (state, action) => ({
      ...state,
      searchPattern: action.payload
    }),
    SET_SELECTED_STATUS_OPTIONS: (state, action) => ({
      ...state,
      selectedStatuses: action.payload
    }),
    SET_SELECTED_TYPES: (state, action) => ({
      ...state,
      selectedTypes: action.payload
    }),
    SET_SELECTED_COUNTRIES: (state, action) => ({
      ...state,
      selectedCountries: action.payload
    }),
    SET_SORT_DATA: (state, action) => {
      const { sortBy } = action.payload;
      return {
        ...state,
        sortBy,
        sortDirection:
          state.sortDirection === SortDirection.ASC
            ? SortDirection.DESC
            : SortDirection.ASC
      };
    },
    RESET_CHECK_DATA: state => ({
      ...state,
      isLoadingCheck: false,
      errorCheckAPI: false,
      checkWasDone: false
    }),
    SET_FILTER: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    FILE_UPLOAD_START: state => ({
      ...state,
      isUploading: true
    }),
    FILE_UPLOAD_END: state => ({
      ...state,
      isUploading: false
    }),
    SET_SHOW_HISTORY_TAB: (state, action) => ({
      ...state,
      showHistoryTab: action.payload
    }),
    RESET_ADVANCED_SEARCH_FILTERS: state => ({
      ...state,
      email: '',
      surname: '',
      name: ''
    })
  },
  extraReducers: {
    [GET_LEAD_LIST._SUCCESS]: (state, action) => ({
      ...state,
      isLoading: false,
      leads: action.payload.leads.map(d => ({
        leadId: d.Id,
        createdOn: moment(d.CreatedDate).format('DD/MM/YYYY'),
        LastModifiedDate: moment(d.LastModifiedDate).format('DD/MM/YYYY'),
        status: StatusLead[d.Status],
        email: d.Email,
        name: d.FirstName,
        surname: d.LastName,
        fullName: `${d.LastName} ${d.FirstName}`,
        type:
          d?.RecordType?.Name.toLowerCase() === 'person'
            ? 'Private'
            : 'Business'
      })),
      totalPagesAvailable: action.payload.totalPages,
      totalRecords: action.payload.totalRecords,
      pageNo: action.payload.page,
      returnedRecords: action.payload.returnedRecords
    }),
    [GET_LEAD_LIST._ERROR]: (state, action) => ({
      ...state,
      isLoading: false,
      leads: action.payload
    }),
    [GET_LEAD_LIST._REQUEST]: (state, action) => ({
      ...state,
      isLoading: true
    }),
    [CREATE_LEAD_B2B._REQUEST]: state => ({
      isLoading: true,
      ...state,
      isLoadingButton: true,
    }),
    [CREATE_LEAD_B2B._ERROR]: state => ({
      isLoading: false,
      ...state,
      isLoadingButton: false,
    }),
    [CREATE_LEAD_B2B._SUCCESS]: state => ({
      isLoading: false,
      ...state,
      isLoadingButton: false,
    }),
    [CREATE_LEAD_B2C._REQUEST]: state => ({
      isLoadingButton: true,
    }),
    [CREATE_LEAD_B2C._ERROR]: state => ({
      isLoadingButton: false,
     
    }),
    [CREATE_LEAD_B2C._SUCCESS]: state => ({
      isLoadingButton: false,
    }),
    [CHECK_LEAD_CREATION._REQUEST]: state => ({
      ...state,
      isLoadingCheck: true,
      errorCheckAPI: false,
      checkWasDone: false
    }),
    [CHECK_LEAD_CREATION._SUCCESS]: (state, action) => ({
      ...state,
      isLoadingCheck: false,
      errorCheckAPI: action?.payload?.exists,
      checkWasDone: true,
      existingLeadId: action?.payload?.leadId
    }),
    [CHECK_LEAD_CREATION._ERROR]: (state, action) => ({
      ...state,
      isLoadingCheck: false,
      errorCheckAPI: true,
      checkWasDone: true,
      existingLeadId: ''
    }),
    [BULK_LEAD_CREATION._REQUEST]: state => ({
      ...state,
      isLoadingCreationBulk: true
    }),
    [BULK_LEAD_CREATION._ERROR]: state => ({
      ...state,
      isLoadingCreationBulk: false
    }),
    [BULK_LEAD_CREATION._SUCCESS]: setCreateAccountsCSVResponse,
    [FETCH_CSV_HISTORY._SUCCESS]: (state, action) => ({
      ...state,
      historyList: action.payload
    }),
    [GET_ROW_ID_STATUS._SUCCESS]: (state, action) => ({
      ...state,
      fileDataList: action.payload
    })
  }
});

export const {
  SHOW_SPINNER,
  HIDE_SPINNER,
  SET_SEARCH_PATTERN,
  SET_SELECTED_STATUS_OPTIONS,
  SET_SELECTED_TYPES,
  SET_SELECTED_COUNTRIES,
  SET_SORT_DATA,
  SET_FILTER,
  RESET_CHECK_DATA,
  SET_SHOW_HISTORY_TAB,
  RESET_ADVANCED_SEARCH_FILTERS
} = leadSlice.actions;

export default leadSlice.reducer;
